import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useLocale, useAssets } from 'hooks';

import { StepContainer, Button } from 'ui';
import { SuccessIcon } from 'ui/icons';
import { AppRoute } from 'routing/AppRoute.enum';
import attachQR from 'assets/images/attachQR.png';
import { AssetDetails } from '../assetDetails/AssetDetails';
import { Asset } from 'hooks/useAssets/useAssets.types';
import { UserRole } from 'context/user/userContext/UserContext.types';

import { useStyles } from './FinishScreen.styles';
import { FinishScreenProps } from './FinishScreen.types';

export const StepFinishScreen = ({
  showAttachmentMessage = true,
  id = 'EUCf-XdLd-oxY6-TpAp',
  userRole = UserRole.Manufacturer,
  skipDetails = false,
}: FinishScreenProps) => {
  const classes = useStyles();
  const { getAssetById } = useAssets();
  const [activeStep, setActiveStep] = useState(1);
  const { formatMessage } = useLocale();
  const { push } = useHistory();
  const asset = getAssetById(id) as Asset;

  const handleNext = () => {
    if (activeStep === 3) {
      push(AppRoute.dashboard);
    } else if (activeStep === 1 && skipDetails) {
      push(AppRoute.dashboard);
    } else if (activeStep === 1 && !showAttachmentMessage) {
      setActiveStep(3);
    } else {
      setActiveStep(s => s + 1);
    }
  };

  const getContent = () => {
    if (activeStep === 1) {
      return (
        <>
          <SuccessIcon color="secondary" />
          <Typography className={classes.title}>{formatMessage({ id: `issue_battery.finish.success` })}</Typography>
        </>
      );
    } else if (activeStep === 2) {
      return (
        <>
          <img src={attachQR} alt="attach QR" />
          <Typography className={classes.title}>
            {formatMessage(
              { id: `issue_battery.finish.qr` },
              { div: msg => <div className={classes.wrapText}>{msg}</div> },
            )}
          </Typography>
        </>
      );
    }
  };

  if (activeStep === 3) {
    return (
      <Grid container className={classes.batteryContainer}>
        {asset && <AssetDetails {...asset} />}
        <Grid item container justify="center" className={classes.batteryActions}>
          <Grid item xs={8}>
            <Button variant="contained" color="primary" onClick={handleNext}>
              {formatMessage({ id: 'common.back_to_dashboard' })}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  const getTitleForRole = () => {
    const defaultTitle = `issue_battery.finish.title${activeStep}`;
    const title = {
      [UserRole.Installer]: `install_battery.finish.title${activeStep}`,
      [UserRole.Owner]: defaultTitle,
      [UserRole.Verifier]: defaultTitle,
      [UserRole.Manufacturer]: defaultTitle,
      [UserRole.GoverningBody]: defaultTitle,
    };

    return title[userRole];
  };

  return (
    <StepContainer title={formatMessage({ id: getTitleForRole() })}>
      <Grid container className={classes.container}>
        <Grid item className={classes.content}>
          {getContent()}
        </Grid>
        <Grid item container className={classes.actions}>
          <Grid item xs={8}>
            <Button variant="contained" color="primary" onClick={handleNext}>
              {formatMessage({ id: 'common.continue' })}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StepContainer>
  );
};
